function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18next from "i18next";
import ReactGA from "react-ga4";
import isDefined from "./isDefined";
export default class GoogleAnalytics {
  constructor() {
    _defineProperty(this, "key", undefined);
    _defineProperty(this, "options", undefined);
  }
  start(configParameters) {
    this.key = configParameters.googleAnalyticsKey;
    this.options = configParameters.googleAnalyticsOptions;
    if (process.env.NODE_ENV === "development") {
      console.log(i18next.t("core.googleAnalytics.logEnabledOnDevelopment"));
    }
    initializeGoogleAnalytics(this);
  }
  logEvent(category, action, label, value) {
    const fieldObject = {
      hitType: "event",
      eventCategory: category,
      eventAction: action
    };
    if (label) {
      fieldObject.eventLabel = label;
    }
    if (isDefined(value)) {
      fieldObject.value = value;
    }
    ReactGA.send(fieldObject);
  }
}
function initializeGoogleAnalytics(that) {
  var _that$options;
  if (!isDefined(that.key)) {
    console.log(i18next.t("core.googleAnalytics.log"));
    return;
  }
  ReactGA.initialize(that.key, {
    gaOptions: _objectSpread({
      anonymizeIp: true
    }, (_that$options = that.options) !== null && _that$options !== void 0 ? _that$options : {}),
    gtagOptions: {
      send_page_view: false
    }
  });
  ReactGA.send({
    hitType: "pageview"
  });
}